'use client'

import { useSession } from 'next-auth/react'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export default function ProfileRedirect() {
  const { data: session, status } = useSession()
  const router = useRouter()

  useEffect(() => {
    if (status === 'loading') return

    if (!session?.user) {
      // If not logged in, redirect to auth
      router.push('/auth')
      return
    }

    // If logged in, redirect to username-based profile
    const username = session.user.username || session.user.name
    if (username) {
      router.push(`/profile/${username}`)
    } else {
      // Fallback if no username
      router.push('/auth')
    }
  }, [session, status, router])

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500 mx-auto mb-4"></div>
        <p className="text-white">Redirecting to your profile...</p>
      </div>
    </div>
  )
}
